import React from "react";

const HorizontalMultiSelect = ({
  label,
  options = [],   // [{ label, value }]
  value = [],     // ["snacks", "drinks"]
  onChange,
}) => {
  const toggleSelect = (val) => {
    if (value.includes(val)) {
      onChange(value.filter((v) => v !== val));
    } else {
      onChange([...value, val]);
    }
  };

  return (
    <div className="w-full">
      {/* {label && (
        <label className="block text-sm font-semibold mb-2">
          {label}
        </label>
      )} */}

      <div className="flex gap-2 overflow-x-auto scrollbar-hide py-1">
        {options.map((opt) => {
          const active = value.includes(opt.value);

          return (
            <button
              key={opt.value}
              onClick={() => toggleSelect(opt.value)}
              className={`whitespace-nowrap px-4 py-1.5 rounded-full text-sm font-medium border transition
                ${
                  active
                    ? "bg-green-600 text-white border-green-600"
                    : "bg-white text-gray-700 border-gray-300 hover:bg-gray-100"
                }`}
            >
              {opt.label}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default HorizontalMultiSelect;
